/* eslint-disable @typescript-eslint/unbound-method */

import { ContentAccessLogApi } from "../clients";
import { wrap } from "../wrap";

export const contentAccessLogApi = {
  postLog: wrap(ContentAccessLogApi, ContentAccessLogApi.prototype.postContentAccessLog),
};
